import React, { FC, useState } from "react";
import { Switch } from "@mui/material";

import {
  Divider,
  FormControlLabel,
  Stack,
  TextField,
  Typography,
} from "@components/base";

const TextFields: FC = () => {
  const [hasError, setHasError] = useState(false);

  return (
    <Stack spacing={4}>
      <Typography variant="h2">Text Fields</Typography>
      <FormControlLabel
        value={hasError}
        control={<Switch />}
        onChange={() => setHasError(!hasError)}
        label="hasError"
      />
      <Divider />
      <Typography variant="subtitle1">Contained</Typography>
      <Stack spacing={2}>
        <Typography variant="subtitle2">Default</Typography>
        <TextField label="Label" error={hasError} />
      </Stack>
      <Stack spacing={2}>
        <Typography variant="subtitle2">Secondary</Typography>
        <TextField label="Label" error={hasError} color="secondary" />
      </Stack>
      <Stack spacing={2}>
        <Typography variant="subtitle2">Disabled</Typography>
        <TextField label="Label" error={hasError} disabled />
      </Stack>
      <Divider />
      <Typography variant="subtitle1">Filled</Typography>
      <Stack spacing={2}>
        <Typography variant="subtitle2">No label, can use placeholder</Typography>
        <TextField variant="filled" placeholder="Placeholder" error={hasError} />
      </Stack>
      <Stack spacing={2}>
        <Typography variant="subtitle1">Secondary</Typography>
        <TextField
          variant="filled"
          placeholder="Placeholder"
          error={hasError}
          color="secondary"
        />
      </Stack>
      <Stack spacing={2}>
        <Typography variant="subtitle1">Disabled</Typography>
        <TextField label="Label" error={hasError} disabled />
      </Stack>
    </Stack>
  );
};

export default TextFields;
